// extracted by mini-css-extract-plugin
module.exports = {"loaderContainer":"LoaderContainer_loaderContainer__1vlel","large":"LoaderContainer_large__2Fri-","medium":"LoaderContainer_medium__1KogN","small":"LoaderContainer_small__KtMwU"};